import React from "react"
import { useLocation } from  'react-router-dom'
import { Navbar, Nav,NavDropdown} from "react-bootstrap"

const HeaderNew = () => {
//assigning location variable
const location = useLocation();

//destructuring pathname from location
const { pathname } = location;

//Javascript split method to get the name of the path in array
const splitLocation = pathname.split("/");  return (
    <header>

<Navbar collapseOnSelect expand="lg">
  {/*<Navbar.Brand href="/">
  <img
        src="/logo_CTS_escala_gris_alta.png"
        width="130"
        height="100"
        className="d-inline-block align-top"
        alt="Cabo Travel Solutions Logo"
      />
</Navbar.Brand>*/}
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav" >
   
    <Nav className="mr-auto justify-content-end" style={{ flex: 1}} >
      <Nav.Link style={{ color: "#FFFFFF"}} className={splitLocation[1] === "" ? "active" : ""} href="/">Home</Nav.Link>
      <Nav.Link style={{ color: "#FFFFFF"}} className={splitLocation[1] === "vehicles" ? "active" : ""} href="/vehicles">About Us</Nav.Link>
        <NavDropdown title={<span style={{color:"white"}}>Services</span>} id="nav-dropdown">
              <NavDropdown.Item  href="/services-rates">Our Vehicles</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">Our Destinations</NavDropdown.Item>
          </NavDropdown>   
      <Nav.Link style={{ color: "#FFFFFF"}} className={splitLocation[1] === "transportations" ? "active" : ""} href="/transportations">Schedule</Nav.Link>

    </Nav>
  </Navbar.Collapse>
</Navbar>    
</header>
  )
}

export default HeaderNew
